import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Switch extends Component {
  static propTypes = {
    /* Defines the text that will be displayed along with the switch */
    label: PropTypes.string,

    /* The switch name */
    name: PropTypes.string,

    /* Defines if the switch is or not disabled */
    disabled: PropTypes.bool,

    /* Callback that will be executed when the switch changes */
    onChange: PropTypes.func,

    /* sets default value */
    defaultValue: PropTypes.bool,
    
    noLabel: PropTypes.bool
  }

  state = {
    /* Defines if the switch is or not checked */
    selected: this.props.defaultValue || false,
  }
  
  onChange(callback) {
    const { selected } = this.state
    this.setState({ selected:  !selected }, () => callback(this.state.selected))
  }

  render() {
    const { selected } = this.state
    const {
      label,
      disabled = false,
      onChange: onChangeCallback = () => {},
      defaultValue,
      noLabel = false,
    } = this.props

    return (
      <>
        <label className={noLabel ? '' : 'switch-label'}>
          <div className='switch-container'>
            <input
              type='checkbox'
              defaultChecked={defaultValue}
              className='switch-input'
              {...this.props}
              onClick={() => this.onChange(onChangeCallback)}
            />
            <span className='slider' />
          </div>
          <span
            className={`switch-label-text ${selected ? 'selected' : ''} ${
              disabled ? 'disabled' : ''
            }`}
          >
            {label}
          </span>
        </label>
      </>
    )
  }
}

export default Switch
